import { render } from "./index.vue?vue&type=template&id=589cc7a5"
import script from "./game-selection-modal.ts?vue&type=script&lang=js"
export * from "./game-selection-modal.ts?vue&type=script&lang=js"

import "./game-selection-modal.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script